module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      cart: true, showing: _vm.showing, 'from-start': _vm.showFromStart, 'remote': !_vm.useStorage
    },
    style: (_vm.showFromStart ? 'position:static;' : '')
  }, [(_vm.showing && _vm.localCart.accomodations) ? _c('div', [(!_vm.useStorage) ? _c('div', [(_vm.localCart.rows.accomodation && _vm.localCart.rows.accomodation.length) ? _c('div', [_c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.accomodation')))])]), _vm._v(" "), _vm._l((_vm.localCart.rows.accomodation), function(row, index) {
    return _c('div', {
      class: 'row ' + (row.cancelled ? 'cancelled' : '')
    }, [_c('div', {
      staticClass: "col type"
    }, [_c('span', [_vm._v(_vm._s(row.accommodation ? (row.accommodation.display_name || row.accommodation.description_title) : row.name))]), _vm._v(" "), (row.accommodation && row.accommodation.subtitle) ? _c('div', {
      staticStyle: {
        "margin-top": "2px",
        "margin-bottom": "8px",
        "font-weight": "300"
      }
    }, [_vm._v("\n              " + _vm._s(row.accommodation.subtitle) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm._f("dateRange")([row.date_arrival, row.date_departure], 'D MMMM', ' - '))) + "\n          ")], 1), _vm._v(" "), (_vm.SITE_CONFIG.add_to_booking_open && _vm.localCart.can_add_to_booking) ? _c('div', {
      staticClass: "col count"
    }, [_c('button', {
      staticClass: "small white border",
      on: {
        "click": function($event) {
          return _vm.bookAddon(row)
        }
      }
    }, [_vm._v("Boka tillval")])]) : _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")((row.quantity * row.price))) + "\n          ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.localCart.rows.addon && _vm.localCart.rows.addon.length) ? _c('div', _vm._l((_vm.localCart.rows.addon), function(row, index) {
    return _c('div', {
      class: 'row ' + (row.cancelled ? 'cancelled' : '')
    }, [_c('div', {
      staticClass: "col type"
    }, [_c('span', [_vm._v(_vm._s(row.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm._f("dateRange")([row.date_arrival, row.date_departure], 'D MMMM', ' - '))) + "\n          ")], 1), _vm._v(" "), (row.quantity != 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n            " + _vm._s(row.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n          ")]) : _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")((row.quantity * row.price))) + "\n          ")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.localCart.rows.skipass && _vm.localCart.rows.skipass.length) ? _c('div', [_c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.skipass')))])]), _vm._v(" "), _vm._l((_vm.localCart.rows.skipass), function(row, index) {
    return _c('div', {
      class: 'row ' + (row.cancelled ? 'cancelled' : '')
    }, [_c('div', {
      staticClass: "col type"
    }, [_c('span', [_vm._v(_vm._s(row.rental ? row.rental.name : row.name) + ", " + _vm._s(row.age_text))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "2px",
        "margin-bottom": "8px",
        "font-weight": "300"
      }
    }, [_vm._v("\n              " + _vm._s(row.pickup === 'DELIVERY' ? 'Utkörning' : row.pickup) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm._f("dateRange")([row.date_arrival, row.date_departure], 'D MMMM', ' - '))) + "\n          ")], 1), _vm._v(" "), (row.quantity != 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n            " + _vm._s(row.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n          ")]) : _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")((row.quantity * row.price))) + "\n          ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.localCart.rows.rental && _vm.localCart.rows.rental.length) ? _c('div', [_c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.equipment')))])]), _vm._v(" "), _vm._l((_vm.localCart.rows.rental), function(row, index) {
    return _c('div', {
      class: 'row ' + (row.cancelled ? 'cancelled' : '')
    }, [_c('div', {
      staticClass: "col type"
    }, [_c('span', [_vm._v(_vm._s(row.rental ? row.rental.name : row.name) + ", " + _vm._s(row.age_text))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "2px",
        "margin-bottom": "8px",
        "font-weight": "300"
      }
    }, [_vm._v("\n              " + _vm._s(row.pickup === 'DELIVERY' ? 'Utkörning' : row.pickup) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm._f("dateRange")([row.date_arrival, row.date_departure], 'D MMMM', ' - '))) + "\n          ")], 1), _vm._v(" "), (row.quantity != 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n            " + _vm._s(row.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n          ")]) : _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")((row.quantity * row.price))) + "\n          ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.localCart.rows.skischool && _vm.localCart.rows.skischool.length) ? _c('div', [_c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.school')))])]), _vm._v(" "), _vm._l((_vm.localCart.rows['skischool']), function(row, index) {
    return _c('div', {
      class: 'row ' + (row.cancelled ? 'cancelled' : '')
    }, [_c('div', {
      staticClass: "col type"
    }, [_c('span', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "8px",
        "margin-bottom": "8px"
      }
    }, [_c('button', {
      staticClass: "small white border",
      on: {
        "click": function($event) {
          return _vm.rowInfo(row)
        }
      }
    }, [_vm._v("Info")])])]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm._f("dateRange")([row.date_arrival, row.date_departure], 'D MMMM', ' - '))) + "\n          ")], 1), _vm._v(" "), (row.quantity != 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n            " + _vm._s(row.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n          ")]) : _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")((row.quantity * row.price))) + "\n          ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.localCart.rows.other && _vm.localCart.rows.other.length) ? _c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.localCart.rows['other']), function(row, index) {
    return _c('div', {
      class: 'row ' + (row.cancelled ? 'cancelled' : '')
    }, [_c('div', {
      staticClass: "col type"
    }, [_c('span', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "2px",
        "margin-bottom": "8px",
        "font-weight": "300"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm._f("dateRange")([row.date_arrival, row.date_departure], 'D MMMM', ' - '))) + "\n          ")], 1), _vm._v(" "), (row.quantity != 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n            " + _vm._s(row.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n          ")]) : _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")((row.quantity * row.price))) + "\n          ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "col"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('general.sum')))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.total-neutrum')) + ": " + _vm._s(_vm._f("currency")(_vm.localCart.sum)))])])]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', [(_vm.localCart.accomodations.filter(function(object) {
    return object.confirmed;
  }).length || _vm.localCart.addons.filter(function(object) {
    return object.confirmed;
  }).length) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.accomodation')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.localCart.accomodations), function(accomodation, index) {
    return (accomodation.confirmed) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(accomodation.name) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n        " + _vm._s(_vm.moment(accomodation.period.date_arrival, 'dddd')) + " - " + _vm._s(_vm.moment(accomodation.period.date_departure, 'dddd')) + "\n           \n        " + _vm._s(_vm.moment(accomodation.period.date_arrival, 'D MMMM')) + " - " + _vm._s(_vm.moment(accomodation.period.date_departure, 'D MMMM')) + "\n      ")], 1), _vm._v(" "), _c('div', {
      class: 'col count hide-on-small'
    }, [_vm._v("\n         \n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n        " + _vm._s(_vm._f("currency")((accomodation.quantity * accomodation.price))) + "\n      ")]), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'accomodations',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.localCart.addons), function(addon, index) {
    return (addon.confirmed && !addon.hide_for_guest) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(addon.title) + "\n        "), (addon.belongsTo > -1 && _vm.localCart.accomodations.filter(function(a) {
      return a.confirmed;
    }).length > 1) ? _c('div', {
      staticClass: "thin"
    }, [_vm._v(_vm._s(_vm.localCart.accomodations[addon.belongsTo].name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date min-tablet"
    }, [_vm._v("\n         \n      ")]), _vm._v(" "), (addon.editableQuantity || addon.quantity > 1) ? _c('div', {
      class: 'col count ' + (addon.quantity > 1 ? '' : 'hide-on-small')
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('general.number')) + ":")]), _vm._v(" "), (addon.editableQuantity) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addon.quantity),
        expression: "addon.quantity"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (addon.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addon, "quantity", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(addon.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")])]) : _c('div', {
      class: 'col count ' + (addon.quantity > 1 ? '' : 'hide-on-small')
    }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), _c('div', {
      class: 'col price ' + (addon.discount ? 'has-discount' : '')
    }, [_vm._v("\n        " + _vm._s(_vm._f("currency")((_vm.number(addon.quantity) * _vm.number(addon.price)))) + "\n        "), (addon.discount) ? _c('div', {
      staticClass: "discount"
    }, [(addon.discount.type === 'percentage' && addon.discount.code === 'rut') ? _c('div', [_vm._v("\n            " + _vm._s(_vm.$t('accomodation.cleaning-tax-reduction')) + ": -" + _vm._s(_vm._f("currency")(((_vm.number(addon.quantity) * _vm.number(addon.price)) * (addon.discount.amount / 100)))) + "\n          ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [(!addon.locked) ? _c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'addons',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1) : _vm._e()]) : _c('div')]) : _vm._e()
  }), _vm._v(" "), (
    _vm.localCart.skipasses.filter(function(object) {
      return object.confirmed && (parseInt(object.adults) || parseInt(object.youths) || parseInt(object.children) || parseInt(object.seniors));
    }).length ||
    _vm.localCart.skipasses.filter(function(object) {
      return object.confirmed && object.type === '';
    }).length
  ) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.skipass')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.localCart.skipasses), function(skipass, index) {
    return (skipass.confirmed && skipass.type === 'SKIPASS-ACCO') ? _c('div', [(!skipass.hideadults) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n          " + _vm._s(skipass.days) + " " + _vm._s(_vm.$t('general.days')) + " / " + _vm._s(_vm.$t('general.ages.adult')) + "\n          "), (skipass.belongsTo > -1 && _vm.localCart.accomodations.filter(function(a) {
      return a.confirmed;
    }).length > 1) ? _c('div', {
      staticClass: "thin"
    }, [_vm._v(_vm._s(_vm.localCart.accomodations[skipass.belongsTo].name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date min-tablet"
    }, [_vm._v("\n           \n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col count"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('general.number')) + ": ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.adults),
        expression: "skipass.adults"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (skipass.adults)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "adults", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_c('PriceView', {
      attrs: {
        "price": _vm.number(skipass.adults) * _vm.number(skipass.adultsPrice),
        "discounted": _vm.accomodationSkipassDiscountedPrice(skipass, 'adult', 'adults')
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")((_vm.number(skipass.adults) * _vm.number(skipass.adultsPrice)))) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'skipasses',
            index: index,
            age: 'adults'
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e(), _vm._v(" "), (!skipass.hideseniors) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n          " + _vm._s(skipass.days) + " " + _vm._s(_vm.$t('general.days')) + " / " + _vm._s(_vm.$t('general.ages.senior')) + "\n          "), (skipass.belongsTo > -1 && _vm.localCart.accomodations.filter(function(a) {
      return a.confirmed;
    }).length > 1) ? _c('div', {
      staticClass: "thin"
    }, [_vm._v(_vm._s(_vm.localCart.accomodations[skipass.belongsTo].name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date min-tablet"
    }, [_vm._v("\n           \n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col count"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('general.number')) + ": ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.seniors),
        expression: "skipass.seniors"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (skipass.seniors)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "seniors", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_c('PriceView', {
      attrs: {
        "price": _vm.number(skipass.seniors) * _vm.number(skipass.seniorsPrice),
        "discounted": _vm.accomodationSkipassDiscountedPrice(skipass, 'senior', 'seniors')
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")((_vm.number(skipass.seniors) * _vm.number(skipass.seniorsPrice)))) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'skipasses',
            index: index,
            age: 'seniors'
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e(), _vm._v(" "), (!skipass.hideyouths) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n          " + _vm._s(skipass.days) + " " + _vm._s(_vm.$t('general.days')) + " / " + _vm._s(_vm.$t('general.ages.youth')) + "\n          "), (skipass.belongsTo > -1 && _vm.localCart.accomodations.filter(function(a) {
      return a.confirmed;
    }).length > 1) ? _c('div', {
      staticClass: "thin"
    }, [_vm._v(_vm._s(_vm.localCart.accomodations[skipass.belongsTo].name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date min-tablet"
    }, [_vm._v("\n           \n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col count"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('general.number')) + ": ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.youths),
        expression: "skipass.youths"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (skipass.youths)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "youths", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_c('PriceView', {
      attrs: {
        "price": _vm.number(skipass.youths) * _vm.number(skipass.youthsPrice),
        "discounted": _vm.accomodationSkipassDiscountedPrice(skipass, 'youth', 'youths')
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")((_vm.number(skipass.youths) * _vm.number(skipass.youthsPrice)))) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'skipasses',
            index: index,
            age: 'youths'
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e(), _vm._v(" "), (!skipass.hidechildren) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n          " + _vm._s(skipass.days) + " " + _vm._s(_vm.$t('general.days')) + " / " + _vm._s(_vm.$t('general.child')) + "\n          "), (skipass.belongsTo > -1 && _vm.localCart.accomodations.filter(function(a) {
      return a.confirmed;
    }).length > 1) ? _c('div', {
      staticClass: "thin"
    }, [_vm._v(_vm._s(_vm.localCart.accomodations[skipass.belongsTo].name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date min-tablet"
    }, [_vm._v("\n           \n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col count"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('general.number')) + ": ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.children),
        expression: "skipass.children"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (skipass.children)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "children", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_c('PriceView', {
      attrs: {
        "price": _vm.number(skipass.children) * _vm.number(skipass.childrenPrice),
        "discounted": _vm.accomodationSkipassDiscountedPrice(skipass, 'child', 'children')
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")((_vm.number(skipass.children) * _vm.number(skipass.childrenPrice)), {
      freeIfZero: true
    })) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'skipasses',
            index: index,
            age: 'children'
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('div', _vm._l((_vm.localCart.skipasses), function(skipass, index) {
    return (skipass.confirmed && (skipass.type === 'SKIPASS' || skipass.type === '')) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n          " + _vm._s(skipass.title) + " / " + _vm._s({
      'children': _vm.$t('general.ages.child'),
      'youths': _vm.$t('general.ages.youth'),
      'adults': _vm.$t('general.ages.adult'),
      'parents': _vm.$t('general.ages.parents'),
      'seniors': _vm.$t('general.ages.senior')
    } [skipass.age]) + "\n          / " + _vm._s(skipass.refill ? _vm.$t('skipass.load') : (skipass.keycardPrice ? _vm.$t('skipass.with-keycard') : '')) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n          " + _vm._s(_vm.moment(skipass.date_arrival, 'D MMMM')) + "\n        ")], 1), _vm._v(" "), _c('div', {
      staticClass: "col count"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('general.number')) + ": ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.quantity),
        expression: "skipass.quantity"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (skipass.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "quantity", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_c('PriceView', {
      attrs: {
        "price": _vm.number(skipass.quantity) * (_vm.number(skipass.price) + (skipass.keycardPrice ? _vm.number(skipass.keycardPrice) : 0)),
        "discounted": skipass.discountedPrice && skipass.discountedPrice > 0 ? (_vm.number(skipass.quantity) * (_vm.number(skipass.discountedPrice) + (skipass.keycardPrice ? _vm.number(skipass.keycardPrice) : 0))) : (skipass.keycardPrice ? _vm.number(skipass.keycardPrice) : 0)
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")((_vm.number(skipass.quantity) * (_vm.number(skipass.price) + (skipass.keycardPrice ? _vm.number(skipass.keycardPrice) : 0))))) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'skipasses',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e()
  }), 0), _vm._v(" "), (_vm.localCart.rentals.filter(function(object) {
    return object.confirmed;
  }).length) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.equipment')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.localCart.rentals), function(rental, index) {
    return (rental.confirmed) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(rental.name)), (rental.insurance) ? _c('span', [_vm._v(" (" + _vm._s(_vm.$t('skirental.incl-insurance')) + ")")]) : _vm._e(), _vm._v(" "), (rental.delivery || rental.deliveryType === 'delivery') ? _c('div', {
      staticClass: "thin"
    }, [_vm._v("Utkörning")]) : _vm._e(), _vm._v(" "), (rental.products || rental.addons) ? _c('ul', [_vm._l((rental.products), function(product) {
      return _c('li', {
        staticClass: "sub"
      }, [_vm._v("\n            " + _vm._s(product.name) + "\n          ")])
    }), _vm._v(" "), _vm._l((rental.addons), function(product) {
      return _c('li', {
        staticClass: "sub"
      }, [_vm._v("\n            " + _vm._s(product.name) + "\n          ")])
    }), _vm._v(" "), (rental.insurance) ? _c('li', {
      staticClass: "sub"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('skirental.insurance.text')) + " "), (!this.SITE_CONFIG.rental.insurance_per_product) ? _c('span', [_vm._v("(" + _vm._s(_vm._f("currency")(rental.insuranceSum)) + ")")]) : _vm._e()]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n        " + _vm._s(_vm.moment(rental.startDate, 'D MMMM')) + ", " + _vm._s((rental.priceType === 'night' && _vm.SITE_CONFIG.site !== 'vallasen') ? '' : rental.days) + " " + _vm._s((rental.priceType === 'night' ?
      ((_vm.SITE_CONFIG.site === 'vallasen' || _vm.SITE_CONFIG.site === 'kungsberget') ? _vm.$t('general.night') : _vm.$t('skirental.day-options.hours', {
        hours: _vm.SITE_CONFIG.rental.night_hours
      })) :
      (rental.days > 1 ? _vm.$t('general.days') : _vm.$t('general.day'))
    )) + "\n      ")], 1), _vm._v(" "), _c('div', {
      class: 'col count ' + (rental.quantity > 1 ? '' : 'hide-on-small')
    }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.SITE_CONFIG.rental.insurance_per_product) ? _c('div', {
      staticClass: "col price"
    }, [(_vm.localCart.campaignCode) ? _c('div', [_c('PriceView', {
      attrs: {
        "price": _vm.getProductPrice(rental),
        "discounted": _vm.getProductPrice(rental, true)
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.localCart.campaignCode) ? _c('div', [_vm._v("\n          " + _vm._s(_vm._f("currency")((rental.quantity * rental.price))) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'rentals',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e()
  }), _vm._v(" "), (_vm.localCart.skischools.filter(function(object) {
    return true;
  }).length) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.school')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.localCart.skischools), function(school, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(school.name) + "\n        "), (school.people.length) ? _c('ul', _vm._l((school.people), function(person) {
      return _c('li', {
        staticClass: "sub"
      }, [_vm._v("\n            " + _vm._s(person.name) + "\n          ")])
    }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n        " + _vm._s(_vm.moment(school.date, 'D MMMM')) + ", " + _vm._s(school.days) + " " + _vm._s(_vm.$t('general.days')) + ", " + _vm._s(school.time) + "\n      ")], 1), _vm._v(" "), (school.quantity > 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n        " + _vm._s(school.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n      ")]) : _c('div', {
      staticClass: "col count hide-on-small"
    }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n        " + _vm._s(_vm._f("currency")((school.quantity * school.price))) + "\n      ")]), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'skischools',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')])
  }), _vm._v(" "), ((_vm.localCart.activities || []).filter(function(object) {
    return true;
  }).length) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.activities')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.localCart.activities), function(activity, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(activity.name) + "\n        "), (activity.people.length) ? _c('ul', _vm._l((activity.people), function(person) {
      return _c('li', {
        staticClass: "sub"
      }, [_vm._v("\n            " + _vm._s(person.name) + "\n          ")])
    }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n        " + _vm._s(_vm.moment(activity.date, 'D MMMM')) + ", " + _vm._s(activity.days) + " " + _vm._s(_vm.$t('general.days')) + ", " + _vm._s(activity.time) + "\n      ")], 1), _vm._v(" "), (activity.quantity > 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n        " + _vm._s(activity.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n      ")]) : _c('div', {
      staticClass: "col count hide-on-small"
    }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n        " + _vm._s(_vm._f("currency")((activity.quantity * activity.price))) + "\n      ")]), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'activities',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')])
  }), _vm._v(" "), ((_vm.localCart.products || []).filter(function(object) {
    return true;
  }).length) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Produkter")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.localCart.products), function(product, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(product.name) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }), _vm._v(" "), _c('div', {
      class: 'col count hide-on-small'
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (product.quantity),
        expression: "product.quantity"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (product.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(product, "quantity", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n        " + _vm._s(_vm._f("currency")((product.quantity * product.price))) + "\n      ")]), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'products',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')])
  }), _vm._v(" "), (_vm.hasDelivery) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Utkörning")])]) : _vm._e(), _vm._v(" "), (_vm.hasDelivery) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col type",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        Utkörning till " + _vm._s((_vm.localCart.deliveryTo && _vm.localCart.deliveryTo.name) ? _vm.localCart.deliveryTo.name : 'ditt boende') + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col date"
  }), _vm._v(" "), _c('div', {
    class: 'col count hide-on-small'
  }), _vm._v(" "), _c('div', {
    staticClass: "col actions"
  }), _vm._v(" "), _c('div', {
    staticClass: "col price"
  }, [_vm._v("\n        " + _vm._s(_vm._f("currency")(0, {
    freeIfZero: true
  })) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col trash"
  }, [_c('button', {
    staticClass: "small trash border",
    on: {
      "click": function($event) {
        return _vm.removeDelivery()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash",
      "scale": 1.5
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "col"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('general.sum')))])]), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
    staticClass: "col",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.total-neutrum')) + ": \n        "), _c('PriceView', {
    attrs: {
      "price": _vm.totalPrice(false),
      "discounted": _vm.totalPrice(true)
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
    staticClass: "col",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.total-neutrum')) + ": " + _vm._s(_vm._f("currency")(_vm.totalPrice())))]) : _vm._e()]), _vm._v(" "), (!_vm.showFromStart) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col right"
  }, [_c('button', {
    staticClass: "small light-blue",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        return _vm.closeCart()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.continue-booking')))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.pay()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.to-checkout')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white"
    }
  })], 1)])]) : _vm._e()], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cart-trigger",
    attrs: {
      "id": "cart-trigger"
    },
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Övrigt")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-216b2fe4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Cart.vue
// module id = 904
// module chunks = 0